import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=5d5a426e&scoped=true&"
import script from "./PaymentMethod.vue?vue&type=script&lang=js&"
export * from "./PaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=5d5a426e&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5a426e",
  null
  
)

export default component.exports